<template>
  <div class="group">
    <input
      :id="identifier"
      :name="identifier"
      type="radio"
      :checked="realValue === value"
      @change="changeValue"
      v-bind="attrs"
    />
    <label
      v-if="label"
      :for="identifier"
      :style="{ width: labelWidth + 'px' }"
      >{{ label }}</label
    >
  </div>
</template>

<script>
export default {
  name: "RadioInput",
  props: ["label", "identifier", "labelWidth", "attrs", "realValue", "value"],
  methods: {
    changeValue(event) {
      if (event.target.checked) {
        this.$emit("input", this.realValue);
        this.$emit("valueChanged");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 15px;
  height: 15px;
  float: left;
}

label {
  margin-top: -1px;
  margin-left: 10px;
  display: block;
  float: left;
}
</style>
